export const productPageSize = 8;

export function productPagePath(page: number) {
  return page <= 1 ? "/products" : `/products/page/${page}`;
}
